/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Skeleton, Typography2 } from '@coursera/cds-core';
import { ArrowNextIcon } from '@coursera/cds-icons';

type Props = {
  headline?: string;
  headlineTarget?: string;
  onClick?: () => void;
};

const styles = {
  container: css`
    min-height: 24px;
    display: flex;
    align-items: center;
  `,
  headline: css`
    color: var(--cds-color-emphasis-neutral-background-xxstrong) !important;
  `,
};

const CompactCollectionHeadline = ({ headline, headlineTarget, onClick }: Props) => {
  if (!headline) {
    return (
      <div>
        <Skeleton variant="text" width="50%" />
      </div>
    );
  }
  return headlineTarget ? (
    <Link
      href={headlineTarget}
      variant="quiet"
      icon={<ArrowNextIcon size="small" />}
      iconPosition="after"
      css={styles.headline}
      onClick={onClick}
      typographyVariant="subtitleMedium"
    >
      {headline}
    </Link>
  ) : (
    <Typography2 component="span" variant="subtitleMedium" css={styles.headline}>
      {headline}
    </Typography2>
  );
};

export default CompactCollectionHeadline;
